import React from 'react';
import { Flex, Box } from 'rebass';

import CTA from '../CTA/CTA';
import Image from '../Image/Image';
import Markup from '../../base/Markup/Markup';
import Typography, {
  TypographyContextProvider,
} from '../Typography/Typography';

import renderStoryblokComponents from '../../utils/renderStoryblokComponents';
import { CarouselSlideStoryblok } from '../../types/storyblok';

const CarouselSlide = ({
  markup,
  title,
  subtitle,
  richText,
  ctaText,
  ctaUrl,
  logo,
  image,
  colourScheme,
}: CarouselSlideStoryblok) => {
  return (
    <TypographyContextProvider value={{ colourScheme }} width={1} px={4}>
      <Flex
        flexWrap="wrap"
        mx={-3}
        alignItems="center"
        justifyContent="space-evenly"
      >
        <Box width={[1, , 2 / 5]} px={[0, 3]} pb={[5, , 0]}>
          <Box width={[2 / 3, , 1]} mx="auto">
            {image && <Image blurLoad minSize="225x200" src={image} />}
          </Box>
        </Box>

        <Box
          width={[1, , 2 / 5]}
          px={3}
          pb={4}
          textAlign={['center', , 'left']}
        >
          {logo && (
            <Box py={5} maxWidth="100px" mx={['auto', , 0]}>
              <Image src={logo} />
            </Box>
          )}

          {markup ? renderStoryblokComponents({ blocks: markup }) : null}

          {title && (
            <Typography component="h3" mb="1em" variant="h4">
              {title}
            </Typography>
          )}

          {subtitle && (
            <Typography component="h4" variant="h3" mb="1em">
              {subtitle}
            </Typography>
          )}

          {richText && <Markup content={richText} />}

          {ctaText && (
            <Box pt={[1, 2, 3]}>
              <CTA href={ctaUrl}>{ctaText}</CTA>
            </Box>
          )}
        </Box>
      </Flex>
    </TypographyContextProvider>
  );
};

export default CarouselSlide;
